// Import Swiper and modules
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const carouselContainerSelector = ".home-hero-carousel";
  const mainCarouselSelector = ".home-hero-carousel-main";
  const thumbsImagesSelector = ".home-hero-carousel-thumbs .swiper-slide img";

  const carouselContainerEl = document.querySelector(carouselContainerSelector);
  const mainCarouselEl = document.querySelector(mainCarouselSelector);

  const MOBILE_BREAKPOINT = 768;

  if (carouselContainerEl && mainCarouselEl) {
    const mainSwiper = new Swiper(mainCarouselEl, {
      modules: [Navigation, Pagination, Autoplay],
      /*       loop: true, */
      slidesPerView: 1,
      spaceBetween: 0,
      /*       autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      }, */
      pagination: {
        el: `${mainCarouselSelector} .swiper-pagination`,
        clickable: true,
      },
      navigation: {
        nextEl: `${mainCarouselSelector} .swiper-button-next`,
        prevEl: `${mainCarouselSelector} .swiper-button-prev`,
      },
    });

    function setupThumbnailHover() {
      const paginationBullets = mainCarouselEl.querySelectorAll(
        ".swiper-pagination-bullet"
      );
      const thumbnailImages = document.querySelectorAll(thumbsImagesSelector);
      const paginationContainer = mainSwiper.pagination.el;

      // Query for existing preview element or create if not present
      let hoverPreviewEl = carouselContainerEl.querySelector(
        ".hover-thumbnail-preview"
      );
      let hoverPreviewImg;

      if (!hoverPreviewEl) {
        hoverPreviewEl = document.createElement("div");
        hoverPreviewEl.className = "hover-thumbnail-preview";
        hoverPreviewImg = document.createElement("img");
        hoverPreviewEl.appendChild(hoverPreviewImg);
        carouselContainerEl.appendChild(hoverPreviewEl);
      } else {
        hoverPreviewImg = hoverPreviewEl.querySelector("img");
      }

      if (
        paginationBullets.length > 0 &&
        thumbnailImages.length > 0 &&
        paginationContainer &&
        hoverPreviewImg
      ) {
        paginationBullets.forEach((bullet, index) => {
          // Check if listeners are already attached to this bullet
          if (bullet.dataset.hoverListenerAttached === "true") {
            return;
          }

          const actualImageIndex = index % thumbnailImages.length;

          if (thumbnailImages[actualImageIndex]) {
            const mouseEnterHandler = () => {
              // Only show preview if on desktop viewport
              if (window.innerWidth > MOBILE_BREAKPOINT) {
                const bulletWidth = bullet.offsetWidth;
                const bulletCenter = bullet.offsetLeft + bulletWidth / 2;
                const previewLeftPosition =
                  mainCarouselEl.offsetLeft +
                  paginationContainer.offsetLeft +
                  bulletCenter;

                hoverPreviewEl.style.left = `${previewLeftPosition}px`;
                hoverPreviewEl.style.width = `${bulletWidth}px`;
                hoverPreviewImg.src = thumbnailImages[actualImageIndex].src;
                hoverPreviewImg.alt = thumbnailImages[actualImageIndex].alt;
                hoverPreviewEl.style.display = "block";
              }
            };

            const mouseLeaveHandler = () => {
              // Always hide on mouse leave, regardless of viewport width
              hoverPreviewEl.style.display = "none";
            };

            bullet.addEventListener("mouseenter", mouseEnterHandler);
            bullet.addEventListener("mouseleave", mouseLeaveHandler);
            bullet.dataset.hoverListenerAttached = "true"; // Mark listeners as attached
          }
        });
      }
    }

    function handleResize() {
      const isDesktop = window.innerWidth > MOBILE_BREAKPOINT;
      const hoverPreviewEl = carouselContainerEl.querySelector(
        ".hover-thumbnail-preview"
      );

      if (isDesktop) {
        setupThumbnailHover(); // Ensures setup if not already done
      } else {
        // If on mobile, ensure the preview is hidden if it exists
        if (hoverPreviewEl) {
          hoverPreviewEl.style.display = "none";
        }
        // Note: We are not removing event listeners here for simplicity.
        // The mouseenter handler's internal width check prevents showing on mobile.
        // If performance became an issue with many bullets, listener removal could be added.
      }
    }

    // Initial check and setup based on current window width
    handleResize();

    // Add a debounced resize event listener
    let resizeTimeout;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleResize, 250);
    });
  }
});
